import { ValidatorsPanel } from './ValidatorsPanel';
import { StatePanel } from './StatePanel';
import { IndexersPanel } from './IndexersPanel';
import { StorageNodesPanel } from './StorageNodesPanel';
import { SHOW_STORAGE_NODES } from '../lib/flags';

interface Props {
  apiUrl: string;
}

export function NetworkPanel({ apiUrl }: Props) {
  return (
    <div>
      <header className="page-header">
        <h1>Network</h1>
        <p>
          Live status of the Willow network — validators producing blocks,
          indexers running pipelines,
          {SHOW_STORAGE_NODES ? ' storage nodes hosting files,' : ''} plus the
          current chain-tip state root.
        </p>
      </header>

      <div className="network-stack">
        <StatePanel />
        <ValidatorsPanel apiUrl={apiUrl} />
        <IndexersPanel apiUrl={apiUrl} />
        {SHOW_STORAGE_NODES && <StorageNodesPanel />}
      </div>
    </div>
  );
}
